import { gql } from 'apollo-boost';


export const GET_BY_ID = gql`
mutation settingById($id: String!) {
    settingById(id: $id) {
      id
      trigger
      condition
      url
      publisherId
      tags
      layoutType { id }
      infiniteScroll
    }
  }
`;

export const GET_ALL_DEFINITIONS = gql`
query getAllDefinitions {
  getAllDefinitions {
      id
      url
      layoutType { 
        name
      }
      tags
    }
  }
`;

export const GET_BY_FIELDS = gql`
query settingByFields($publisherId: String!, $url: String!, $isMobile: Boolean!) {
  settingByFields(publisherId: $publisherId, url: $url, isMobile:$isMobile) {
    id
    trigger
    condition
    url
    publisherId
    tags
    layoutType { id }
    infiniteScroll
    }
  }
`;

export const GET_BY_PUBLISHER_ID = gql`
query settingByPublisherId($publisherId: String!) {
  settingByPublisherId(publisherId: $publisherId) {
    id
    trigger
    condition
    url
    publisherId
    tags
    layoutType { id }
    infiniteScroll
    }
  }
`

export const ADD = gql`
  mutation createSetting($url: String!, $layoutType: String!, $publisherId: String!, $trigger: SettingTrigger!, $condition: SettingCondition!, $infiniteScroll: Boolean!) {
    createSetting(input: { url: $url, layoutType: $layoutType, publisherId: $publisherId, trigger:$trigger, condition:$condition, infiniteScroll: $infiniteScroll   }) {
      id
      trigger
      condition
      url
      publisherId
      tags
      layoutType { id }
      infiniteScroll
    }
  }
`;

export const EDIT = gql`
  mutation updateSetting($id: String!, $url: String!, $layoutType: String!, $publisherId: String!,$trigger: SettingTrigger!, $condition: SettingCondition!, $infiniteScroll: Boolean!) {
    updateSetting(id: $id, input: {  url: $url, layoutType: $layoutType, publisherId: $publisherId, trigger:$trigger, condition:$condition, infiniteScroll: $infiniteScroll }) {
      id
      trigger
      condition
      url
      publisherId
      tags
      layoutType { id }
      infiniteScroll
    }
  }
`;

export const DELETE = gql`
mutation deleteSetting($id: String!) {
  deleteSetting(id: $id) {
    id
    publisherId
    url
  }
}
`;
